import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

// JMB brand palette (JMB_App_UI_Style_Spec). Both the stock Vuetify roles
// (primary/secondary/accent/error/info/success/warning/anchor) and custom
// brand tokens (navy/brandRed/ink/line/stripe/…) are mapped so `color="..."`
// anywhere in the app resolves to spec hexes.
const light = {
  primary: "#01014C", // navy-900
  secondary: "#1976D2", // blue-600 (secondary / action)
  accent: "#E7232B", // red-500 (brand accent)
  error: "#C62828", // danger
  info: "#1565C0", // info
  success: "#2E7D32",
  warning: "#9A4D00",
  anchor: "#1976D2", // links

  // custom brand tokens
  navy: "#01014C",
  navy700: "#1B1B5E",
  navy50: "#E7E8F3",
  brandRed: "#E7232B",
  blue700: "#1565C0",
  ink: "#1A1B3A",
  ink2: "#4A4C6E",
  ink3: "#6B6E86",
  line: "#C9CCD8",
  lineSoft: "#E3E5ED",
  stripe: "#F2F3F7",
  appbg: "#F5F6FA",
  surface: "#FFFFFF",
};

// Dark mode: spec swaps tokens only. Navy stays the brand; action blue and
// accent red are brightened for contrast, surfaces/ink use the dark tokens.
const dark = {
  primary: "#01014C", // navy (sidebar/app bar stay navy)
  secondary: "#5B9BE6", // action blue (dark)
  accent: "#F06A6F", // accent red (dark)
  error: "#F06A6F",
  info: "#5B9BE6",
  success: "#66BB6A",
  warning: "#E8A33D",
  anchor: "#5B9BE6",

  navy: "#0A0B3A",
  navy700: "#1B1B5E",
  navy50: "#1F2347",
  brandRed: "#F06A6F",
  blue700: "#5B9BE6",
  ink: "#E6E7F0",
  ink2: "#A8ABC4",
  ink3: "#8A8DA3",
  line: "#2E3360",
  lineSoft: "#1F2347",
  stripe: "#1F2347",
  appbg: "#0E1024",
  surface: "#161935",
};

export default new Vuetify({
  theme: {
    options: { customProperties: true },
    themes: { light, dark },
  },
});
